import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const SharedFolderFileIcon = createSvgIcon(
  <g className="cd-folder-icon">
    <path
      d="M8 15.8c0-1.9 1.5-3.4 3.4-3.4h16.4c.9 0 1.8.4 2.3 1.2l2.1 3.1H52c2.3 0 4.2 1.9 4.2 4.2v2.4H8V15.8z"
      fill="var(--cd-folder-tab, #e07a1f)"
    />
    <path
      d="M6.4 23.2c0-2.5 2-4.5 4.5-4.5h42.2c2.5 0 4.5 2 4.5 4.5v24.6c0 2.5-2 4.5-4.5 4.5H10.9c-2.5 0-4.5-2-4.5-4.5V23.2z"
      fill="var(--cd-folder, #ff5e1f)"
    />
    <circle cx="32" cy="35.2" r="5" fill="var(--cd-folder-line, #fff)" />
    <path
      d="M22.4 47c1.6-4.2 5.3-6.5 9.6-6.5s8 2.3 9.6 6.5"
      fill="none"
      stroke="var(--cd-folder-line, #fff)"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </g>,
  'SharedFolderFileIcon',
);
